import React from "react";

function SideBar() {
    return (
        <section className="col-md-4">
            <h1>This is the side bar</h1>
            <h2>Fyzan's Tasks</h2>
            <ul>
                <li>Full Logo</li>
                <li>Square Logo</li>
                <li>Favicon</li>
                <li>Website colour scheme</li>
                <li>Website Fonts</li>
                <li>Design the website on figma</li>
            </ul>
        </section>
    );
}

export default SideBar;